export const getCampaignContributionsState = (state: Record<string, any>) =>
  state.iterableGoals.goalAnalytics.campaignContribution;
